const format = new Intl.NumberFormat('de-CH')
export const nF = a => format.format(a)
